export const THEME_STORAGE_KEY = 'paperboi-theme';

/**
 * Runs before first paint (injected into <head> as an inline script in the
 * root layout) to avoid a theme flash. It applies the persisted choice
 * as an explicit class so it
 * overrides the `prefers-color-scheme` fallback in styles/theme/base.css:
 *   - stored 'dark'  → .dark-mode  (force dark)
 *   - stored 'light' → .light-mode (force light, beats system dark)
 *   - nothing stored → no class    (system preference decides)
 */
export const THEME_INIT_SCRIPT = `(function(){try{var t=localStorage.getItem('${THEME_STORAGE_KEY}');var e=document.documentElement;if(t==='dark'){e.classList.add('dark-mode');}else if(t==='light'){e.classList.add('light-mode');}}catch(err){}})();`;
